export interface GameConfig {
  scene: {
    background: number;
    fog: {
      color: number;
      near: number;
      far: number;
    };
    camera: {
      fov: number;
      position: { x: number; y: number; z: number };
      lookAt: { x: number; y: number; z: number };
      returnSpeed: number;
    };
    lighting: {
      ambientIntensity: number;
      directionalIntensity: number;
      directionalPosition: { x: number; y: number; z: number };
    };
  };
  characters: {
    player: {
      position: { x: number; y: number; z: number };
      rotation: { x: number; y: number; z: number };
      scale: number;
    };
    opponent: {
      position: { x: number; y: number; z: number };
      rotation: { x: number; y: number; z: number };
      scale: number;
    };
  };
}

export const defaultConfig: GameConfig = {
  scene: {
    background: 0x1a1a2e,
    fog: {
      color: 0x1a1a2e,
      near: 5,
      far: 40
    },
    camera: {
      fov: 45,
      position: { x: -4, y: 3.5, z: 7 },
      lookAt: { x: -0.45, y: 1, z: 0 },
      returnSpeed: 0.05
    },
    lighting: {
      ambientIntensity: 0.6,
      directionalIntensity: 1.0,
      directionalPosition: { x: 5, y: 10, z: 5 }
    }
  },
  characters: {
    player: {
      position: { x: -2, y: 0, z: 0 },
      rotation: { x: 0, y: Math.PI / 2, z: 0 },
      scale: 0.01
    },
    opponent: {
      position: { x: 2, y: 0, z: 0 },
      rotation: { x: 0, y: -Math.PI / 2, z: 0 },
      scale: 0.01
    }
  }
};
